/**
 * Wrapper classes for the notification column. The toast-lift browser harness
 * (e2e-harness/main.tsx) imports this rather than copying the string, so it renders the exact
 * production geometry and pointer-events. ENG-4897 shipped because that copy went stale.
 *
 * Notices stay interactive while a dialog is open. The stack lifts clear of every registered
 * dialog footer (design-system dialog/protected-footer.ts), so the column does not need to
 * suppress pointer events to keep footer buttons clickable. Disabling them while the dialog
 * holds the column aria-hidden froze the hover-expanded stack and made notice actions dead.
 */
export const PanelClassName = 'pointer-events-none absolute inset-y-0 right-0 z-70';
